import { useMemo } from 'react';
import { PageLayout, Pagination } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { AppRoute } from 'routing/AppRoute.enum';
import { Table } from 'ui/table/Table';
import { PresenceLocationState } from '../CurrentPresence.types';
import { PresenceRefreshSelect } from '../presenceRefreshSelect/PresenceRefreshSelect';

import * as Styled from './CurrentPresenceOwners.styles';
import { CurrentPresenceOwnerRow, CurrentPresenceOwnersProps } from './CurrentPresenceOwners.types';
import { CURRENT_PRESENCE_OWNERS_COLUMNS } from './CurrentPresenceOwners.variables';
import { CurrentPresenceOwnersTableHeader } from './currentPresenceOwnersTableHeader/CurrentPresenceOwnersTableHeader';
import { CurrentPresenceOwnersTableRow } from './currentPresenceOwnersTableRow/CurrentPresenceOwnersTableRow';

export const CurrentPresenceOwners = ({
  ownersResponse,
  isLoading,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  refetchInterval,
  setRefetchInterval,
}: CurrentPresenceOwnersProps) => {
  const { formatMessage } = useLocale();

  const rows = useMemo<CurrentPresenceOwnerRow[]>(
    () => (ownersResponse?.data ?? []).map((owner) => ({ ...owner, id: owner.pkdId })),
    [ownersResponse],
  );

  return (
    <PageLayout
      header={formatMessage({ id: AppMessages['events.currentPresenceOwners.title'] })}
      withBackButton={{
        onClick: (navigate) => {
          const state: PresenceLocationState = { refetchInterval };

          navigate(AppRoute.eventsCurrentPresence, { state });
        },
      }}
      renderContent={() => (
        <Table
          isLoading={isLoading}
          // Same toolbar as Zdarzenia → Bieżące: pagination on the left, refresh select on the right.
          renderAdditionalTopElement={() => (
            <Styled.PaginationWrapper>
              <Pagination
                page={page}
                setPage={setPage}
                count={ownersResponse?.count || 0}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
              />

              <PresenceRefreshSelect refetchInterval={refetchInterval} setRefetchInterval={setRefetchInterval} />
            </Styled.PaginationWrapper>
          )}
          testIdKey="pkdId"
          gridTemplateColumns={CURRENT_PRESENCE_OWNERS_COLUMNS}
          data={rows}
          nothingToShowText={formatMessage({ id: AppMessages['events.currentPresenceOwners.nothingToShow'] })}
          renderHeader={() => <CurrentPresenceOwnersTableHeader />}
          renderRow={(owner) => <CurrentPresenceOwnersTableRow owner={owner} />}
        />
      )}
    />
  );
};
